// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async (response) => {
    // console.log(response)

    const offcanvasCart = document.querySelector('#offcanvas-cart')

    offcanvasCart?.classList.add('loading')

    const rspns = await fetch(window.location.href)
    const text = await rspns.text()
    const newDocument = new DOMParser().parseFromString(text, 'text/html')

    offcanvasCart?.querySelector('.offcanvas-body')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-body'))
    offcanvasCart?.querySelector('.offcanvas-footer')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-footer'))

    document.querySelector('#cart')?.replaceWith(newDocument.querySelector('#cart'))

    document.querySelectorAll('.cart-count-badge').forEach((badge) => {
        badge.textContent = newDocument.querySelector('.cart-count-badge').textContent
        badge.removeAttribute('hidden')
    })

    offcanvasCart?.classList.remove('loading')

    window.dispatchEvent(new Event('updated.sd.cart'))

    if (response.ok) {
        if (response.url.includes('add.js')) {
            offcanvasCart?.querySelector('#offcanvas-cart-alert-add').removeAttribute('hidden')
        } else {
            offcanvasCart?.querySelector('#offcanvas-cart-alert-updated').removeAttribute('hidden')
        }
    } else {
        const data = await response.json()
        const alert = document.querySelector('#offcanvas-cart-alert-error')
        alert.querySelector('span').textContent = `${data.message} - ${data.description}`
        alert.removeAttribute('hidden')
    }

    // Get the cart data from Shopify's AJAX API
    const cartDataResponse = await fetch('/cart.js')
    const cartData = await cartDataResponse.json()

    const cartSubtotalValue = cartData.total_price / 100 // The total_price is in cents, convert to dollars
    const percentage = Math.min((cartSubtotalValue / 40) * 100, 100) // Ensure percentage does not exceed 100

    const progressBar = document.querySelector('.progress .progress-bar')
    if (progressBar) {
        progressBar.style.width = `${percentage}%`
        progressBar.setAttribute('aria-valuenow', percentage)
    }
    // Calculate amount needed for free shipping
    const amountNeeded = Math.max(40 - cartSubtotalValue, 0)

    // Find the element and update its text content
    const amountNeededElement = document.querySelector('.amount-needed')
    if (amountNeededElement) {
        amountNeededElement.textContent = `$${amountNeeded.toFixed(2)}`
    }

    // Manage the visibility of fs-progress and fs-target based on cartSubtotalValue
    const fsProgress = document.querySelector('.fs-progress')
    const fsTarget = document.querySelector('.fs-target')

    if (cartSubtotalValue >= 40) {
        fsProgress?.classList.add('d-none')
        fsTarget?.classList.remove('d-none')
    } else {
        fsProgress?.classList.remove('d-none')
        fsTarget?.classList.add('d-none')
    }
}

// Quantity Inputs
window.onChangeCartQty = async (input) => {
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: input.dataset.lineItemKey,
            quantity: input.value
        })
    })
    window.refreshCartContents(response)
}

function decreaseQuantity(button) {
    const input = button.nextElementSibling;
    let value = parseInt(input.value);
    if (value > 1) {
        value--;
        input.value = value;
        onChangeCartQty(input);
    }
}

function increaseQuantity(button) {
    const input = button.previousElementSibling;
    let value = parseInt(input.value);
    value++;
    input.value = value;
    onChangeCartQty(input);
}


// Remove Buttons
window.onRemoveCartItem = async (btn) => {
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: btn.dataset.lineItemKey,
            quantity: 0
        })
    })
    window.refreshCartContents(response)
}

// Checkout button - indicate loading on click
window.onClickCheckoutBtn = (btn) => {
    btn.style.height = btn.clientHeight + 'px'
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
}

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
    const card = document.querySelector('#cart-summary')

    if (!card) return

    if (window.matchMedia('max-width: 991px').matches) return

    const navbarHeight = document.querySelector('#shopify-section-navbar.sticky-top').clientHeight || 0
    card.style.position = 'sticky'
    card.style.top = `${navbarHeight + 20}px`
}
initStickySummaryCard()

window.addEventListener('updated.sd.cart', () => {
    initStickySummaryCard()
})

// Cart Attributes
window.updateCartAttribute = async (name, value) => {
    const data = {
        attributes: {}
    };
    data.attributes[name] = value;

    const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    
    // No need to refresh the entire cart for attribute updates
    return response;
}

// Initialize cart attribute event listeners
const initCartAttributes = () => {
    // Gift Note textarea
    const giftNoteTextarea = document.getElementById('comment-special-instructions');
    if (giftNoteTextarea) {
        giftNoteTextarea.addEventListener('change', (e) => {
            updateCartAttribute('Gift Note', e.target.value);
        });
    }

    // Gift checkbox
    const giftCheckbox = document.getElementById('giftCheck');
    if (giftCheckbox) {
        giftCheckbox.addEventListener('change', (e) => {
            updateCartAttribute('Gift', e.target.checked ? 'Yes' : 'No');
        });
    }
}

// Call initialization on page load
initCartAttributes();

// Reinitialize after cart updates
window.addEventListener('updated.sd.cart', () => {
    initStickySummaryCard();
    initCartAttributes();
});
